"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ProductName = _ref => {
  let {
    prefix,
    productNameHeadingTag,
    name,
    children,
    className
  } = _ref;
  if (!name) return null;
  const HeadingTag = productNameHeadingTag;
  return _react.default.createElement(HeadingTag, {
    className: `${prefix}price-module__name`
  }, _react.default.createElement("span", {
    className: `${prefix}price-module__name-decorator`
  }, name), " ", children);
};
ProductName.defaultProps = {
  productNameHeadingTag: 'div',
  prefix: ''
};
var _default = ProductName;
exports.default = _default;